'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (object) {
  return function (style) {
    if (typeof object === 'function') {
      return object(style);
    }

    return object[style];
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/draft-convert/lib/util/styleObjectFunction.js
// module id = ./node_modules/draft-convert/lib/util/styleObjectFunction.js
// module chunks = main